import { render, staticRenderFns } from "./MachineDetail.vue?vue&type=template&id=6f5154f3&scoped=true&"
import script from "./MachineDetail.vue?vue&type=script&lang=ts&"
export * from "./MachineDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MachineDetail.vue?vue&type=style&index=0&id=6f5154f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5154f3",
  null
  
)

export default component.exports